import * as types from "../actions/actionsTypes"

let initialState = {
    idInterstitials: [],
}

const interstitialReducer = (state = initialState.idInterstitials, action) => {
    switch (action.type) {
        case types.SET_INTERSTITIALS:
            return [...state, action.data]

        default:
            return state
    }
}

export default interstitialReducer